import SiteActions from './SiteActions';

export const setMobile = isMobile => dispatch => {
    dispatch(SiteActions.setMobile(isMobile));
};
